import React, { Component } from 'react';
import Vas from '../Vas';
//import '../css/Tariffing.css';
import { LinkButton } from 'component-lib';

class ErrorOnline  extends Component {

    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        this.history = props.history;
    }

    render()
    {
      let text = Vas.Resources.Labels["ErrorOffline"];
      let textArray = null;
      if(localStorage.getItem('ErrorMessage')){
        text = localStorage.getItem('ErrorMessage');
        textArray = text.split(";");
      }

      if(textArray.length > 0){
        return (<div className="TariffingContainer" >
          <div 
            className={"tariffingform"} 
            style={{ textAlign:'left' }}>
            <br />
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Titles["Error"]}</h2></th>
                </tr>
              </thead>
              <tbody>
              <tr>
                    <td colSpan={2} style={{ fontSize:'14px'}}>{textArray[0]}</td><br/><br/>
                </tr>
                <tr>
                  <td>Zeitpunkt des Auftretens:</td>
                  <td style={{ fontSize:'14px'}}>{textArray[1]}</td> 
                </tr>
                <tr>
                  <td>Http-Statuscode:</td>
                  <td style={{ fontSize:'14px'}}>{textArray[2]}</td> 
                </tr>
                <tr>
                  <td>Fehlercode:</td>
                  <td style={{ fontSize:'14px'}}>{textArray[3]}</td> 
                </tr>
                <tr>
                  <td>Fehlertext:</td>
                  <td style={{ fontSize:'14px'}}>{textArray[4]}</td>
                </tr>
                <tr>
                  <td><br/> Hier kommen Sie zurück zur </td>
                  <td style={{ fontSize:'14px'}}><br/>
                    <LinkButton 
                      Text={Vas.Resources.Labels["Back"]} 
                      Id={"LinkLogin"} 
                      OnClick={()=>{
                        if(localStorage.getItem('Error')){
                          localStorage.removeItem('Error');
                        }
                        this.history.goBack();
                      }} />
                  </td>
                </tr>
              </tbody>
            </table> 
            </div>
        </div>);
      } else{
        return (<div className="TariffingContainer" >
          <div 
            className={"tariffingform"} 
            style={{ textAlign:'left' }}>
            <br />
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Titles["Error"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontSize:'14px'}}>{text}</td>
                  </tr>
                <tr>
                  <td style={{ fontSize:'14px'}}>
                    <LinkButton 
                      Text={Vas.Resources.Labels["Back"]} 
                      Id={"LinkLogin"} 
                      OnClick={()=>{
                        if(localStorage.getItem('Error')){
                          localStorage.removeItem('Error');
                        }
                        this.history.goBack();
                      }} />
                  </td>
                </tr>
              </tbody>
            </table> 
            </div>
        </div>);
      }
    }
}
export default ErrorOnline;
